import { Box } from '@chakra-ui/react';
import { useMelioIntl } from '@melio/ar-domain';
import { Group, SelectionCard } from '@melio/penny';
import { FundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { AddFundingSourceCard } from './AddFundingSourceCard';

export type AddFundingSourceCardListProps = {
  onSelect: (fundingSourceType: FundingSource['type']) => void;
};

export const AddFundingSourceCardList = forwardRef<AddFundingSourceCardListProps>(({ onSelect, ...props }, ref) => {
  const { formatMessage } = useMelioIntl();

  return (
    <Group variant="vertical" data-component="AddFundingSourceCardList" {...props} ref={ref}>
      <AddFundingSourceCard type="bank-account" onSelect={onSelect} data-testid="select-bank-account" />
      <AddFundingSourceCard type="card" onSelect={onSelect} data-testid="select-card" />
      <Box pointerEvents="none" userSelect="none" opacity="0.8">
        <SelectionCard
          icon="mobile"
          mainLabelProps={{
            label: formatMessage('ar.guestPayment.activities.paymentMethods.appleOrGoogle.label'),
          }}
          descriptionProps={{
            label: formatMessage('ar.guestPayment.activities.paymentMethods.appleOrGoogle.description.text'),
          }}
        />
      </Box>
    </Group>
  );
});

AddFundingSourceCardList.displayName = 'AddFundingSourceCardList';
